export enum EFormaVisualizacaoMovimentoConta {
    Analitica = 1,
    Sintetica = 2,
}
